import type { Eip1193Provider } from 'ethers'
import { TxCard } from './TxCard.js'
import type { DecideResponse, PendingTx } from '../types.js'

interface Props {
  txs: PendingTx[]
  decisions: Map<string, DecideResponse>
  decisionErrors: Map<string, string>
  guardianAddress: string | null
  moduleSafe: string
  safewardUrl: string
  safewardAuthToken: string
  walletProvider: Eip1193Provider | undefined
  signerAddress: string | undefined
  onAfterSign: () => void
}

export function PendingTxList({
  txs,
  decisions,
  decisionErrors,
  guardianAddress,
  moduleSafe,
  safewardUrl,
  safewardAuthToken,
  walletProvider,
  signerAddress,
  onAfterSign,
}: Props) {
  if (txs.length === 0) {
    return (
      <div className="mb-4 rounded-xl border bg-card py-10 text-center text-sm text-muted-foreground shadow-sm">
        No pending transactions on the Module Safe.
      </div>
    )
  }

  // Latest = highest nonce. Only that tx is safe to delete without leaving a
  // nonce gap that would block every later tx from executing.
  const latestNonce = txs.reduce((max, t) => (t.nonce > max ? t.nonce : max), -Infinity)

  return (
    <>
      {txs.map((tx) => (
        <TxCard
          key={tx.safeTxHash}
          tx={tx}
          decision={decisions.get(tx.safeTxHash)}
          decisionError={decisionErrors.get(tx.safeTxHash)}
          guardianAddress={guardianAddress}
          moduleSafe={moduleSafe}
          safewardUrl={safewardUrl}
          safewardAuthToken={safewardAuthToken}
          isLatest={tx.nonce === latestNonce}
          walletProvider={walletProvider}
          signerAddress={signerAddress}
          onAfterSign={onAfterSign}
        />
      ))}
    </>
  )
}
